import { render, staticRenderFns } from "./RegistrationOtp.vue?vue&type=template&id=b798851c&"
import script from "./RegistrationOtp.vue?vue&type=script&lang=js&"
export * from "./RegistrationOtp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports